var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{staticClass:"print-modal",attrs:{"fullscreen":"","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('PrintDocument',{attrs:{"doc_form":_vm.doc_form,"doc_id":_vm.doc_id,"doc_type":_vm.doc_type,"modal":_vm.dialog},on:{"closeModal":_vm.closeDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }